import React from "react";
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, arrayMove, rectSortingStrategy, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { X, GripVertical } from "lucide-react";
import { API_BASE } from "../lib/api";

function resolveSrc(u) {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/media/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
}

function SortableItem({ id, url, onRemove }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.5 : 1 };
  return (
    <div ref={setNodeRef} style={style} className="relative group border border-black/10 rounded overflow-hidden" data-testid={`sortable-${id}`}>
      <img src={resolveSrc(url)} alt="" className="w-full h-32 object-cover" />
      <div className="absolute top-1 left-1 bg-black/70 text-white rounded p-1 cursor-grab active:cursor-grabbing" {...attributes} {...listeners}><GripVertical className="w-3 h-3" /></div>
      <button type="button" onClick={() => onRemove(id)} className="absolute top-1 right-1 bg-red-500 text-white rounded p-1 opacity-0 group-hover:opacity-100 transition" data-testid={`remove-${id}`}><X className="w-3 h-3" /></button>
    </div>
  );
}

export default function SortableImages({ items, onChange }) {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));
  const ids = items.map((_, i) => `img-${i}`);

  const handleEnd = (e) => {
    const { active, over } = e;
    if (!over || active.id === over.id) return;
    const oldIndex = ids.indexOf(active.id);
    const newIndex = ids.indexOf(over.id);
    onChange(arrayMove(items, oldIndex, newIndex));
  };

  const remove = (id) => {
    const idx = ids.indexOf(id);
    onChange(items.filter((_, i) => i !== idx));
  };

  if (!items.length) return <div className="text-xs text-neutral-500 py-4 text-center">Nenhuma imagem ainda.</div>;
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleEnd}>
      <SortableContext items={ids} strategy={rectSortingStrategy}>
        <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
          {items.map((url, i) => (<SortableItem key={ids[i]} id={ids[i]} url={url} onRemove={remove} />))}
        </div>
      </SortableContext>
    </DndContext>
  );
}
